import * as _ from 'lodash-es';
import { LuxDt } from './timeF/Date1TimeF.mts';
import { dur2Human } from './langF/dur2HumanF.mts';
export const betLogFormatters = [];
export const notFormatted = Symbol('notFormatted');
export const betInspect = (arg, key) => {
    for (const fmt of betLogFormatters) {
        const result = fmt(arg, key);
        if (result !== notFormatted)
            return result;
    }
    if (_.isString(arg) && (_.startsWith(arg, 'data:') && arg.length > 100)) {
        return arg.slice(0, 20) + '...';
    }
    if (arg == 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855')
        return 'emptyStrSha256';
    if (_.isString(arg) && arg.length < 40 && arg.match(/\+\d{2}\:\d{2}$/)) {
        arg = LuxDt.fromISO(arg);
    }
    if (arg?.isLuxonDuration) {
        return dur2Human(arg);
    }
    if (arg?.isLuxonInterval) {
        return _.map([arg.start, arg.end], betInspect);
    }
    if (arg?.isLuxonDateTime) {
        const { invalidReason } = arg;
        if (invalidReason) {
            return betInspect({ invalidReason });
        }
        return 'lxdt' + arg.toISO();
    }
    if (_.isDate(arg)) {
        return 'jsdt' + betInspect(LuxDt.fromJSDate(arg));
    }
    if (_.isArray(arg)) {
        return _.map(arg, betInspect);
    }
    if (_.isPlainObject(arg))
        return _.mapValues(arg, betInspect);
    return arg;
};
